import React from 'react';

import { neptuneUrls } from '@neptune/shared/common-domain';
import { Link, LinkProps } from '@neptune/shared/venus-ui';

type ContactSupportProps<P extends object> = LinkProps<P>;

export function ContactSupport<P extends object>(props: ContactSupportProps<P>) {
  return <Link {...props} href={neptuneUrls.supportUrl} />;
}
